import React, { useState } from 'react';
import CircularProgress from '../survey/CircularProgress';

const Accordion = ({
  title = '',
  defaultOpen = false,
  score = '',
  desiredScore = null,
  children,
  color = '#006B00',
}) => {
  const [expanded, setExpanded] = useState(defaultOpen);

  return (
    <div className="relative antialiased">
      <main className="overflow-hidden relative">
        <div
          className="w-full"
          style={{
            backgroundColor: 'white',
            border: `2px solid ${color}`,
            borderRadius: '20px',
          }}
        >
          <div className="divide-y divide-slate-200 p-6">
            <div>
              <h2>
                <div className="w-full">
                  <button
                    id="faqs-title-07"
                    type="button"
                    className="flex items-center justify-between w-full text-left"
                    onClick={() => setExpanded(!expanded)}
                    aria-expanded={expanded}
                    aria-controls="faqs-text-07"
                  >
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center w-full">
                      <p className="capitalize font-bold mb-2 sm:mb-0">{title}</p>
                      <div className="hidden sm:flex gap-5 items-center">
                        {typeof score === 'number' && (
                          <div className="flex flex-col items-center w-24 h-24">
                            <CircularProgress
                              value={score > 10 ? score : score * 10}
                              color={color}
                              showPercentageValue={false}
                            />
                            <span className="text-xs text-gray-500 mt-2">Huidig</span>
                          </div>
                        )}
                        {typeof desiredScore === 'number' &&
                          ((desiredScore * 10) - (score > 10 ? score : score * 1) >= 5) && (
                          <div className="flex flex-col items-center w-24 h-24">
                            <CircularProgress
                              value={desiredScore * 10}
                              color={color}
                              showPercentageValue={false}
                            />
                            <span className="text-xs mt-2">Gewenst</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <span className="w-[68px] flex justify-center flex-shrink-0">
                      <svg
                        className="shrink-0"
                        width="16"
                        height="16"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="#052e16"
                      >
                        <rect
                          y="7"
                          width="16"
                          height="2"
                          rx="1"
                          className={`transform origin-center transition duration-200 ease-out ${
                            expanded ? '!rotate-180' : ''
                          }`}
                        />
                        <rect
                          y="7"
                          width="16"
                          height="2"
                          rx="1"
                          className={`transform origin-center rotate-90 transition duration-200 ease-out ${
                            expanded ? '!rotate-180' : ''
                          }`}
                        />
                      </svg>
                    </span>
                  </button>
                  
                  {/* Mobile CircularProgress components - shown below title on mobile */}
                  <div className="flex sm:hidden gap-4 items-center justify-center mt-4 pb-2">
                    {typeof score === 'number' && (
                      <div className="flex flex-col items-center">
                        <div className="w-16 h-16">
                          <CircularProgress
                            value={score > 10 ? score : score * 10}
                            color={color}
                            showPercentageValue={false}
                          />
                        </div>
                        <span className="text-xs text-gray-500 mt-2">Huidig</span>
                      </div>
                    )}
                    {typeof desiredScore === 'number' &&
                      ((desiredScore * 10) - (score > 10 ? score : score * 1) >= 5) && (
                      <div className="flex flex-col items-center">
                        <div className="w-16 h-16">
                          <CircularProgress
                            value={desiredScore * 10}
                            color={color}
                            showPercentageValue={false}
                          />
                        </div>
                        <span className="text-xs mt-2">Gewenst</span>
                      </div>
                    )}
                  </div>
                </div>
              </h2>
              <div
                id="faqs-text-07"
                role="region"
                aria-labelledby="faqs-title-07"
                className={`grid overflow-hidden transition-all duration-500 ease-in-out ${
                  expanded
                    ? 'grid-rows-[1fr] opacity-100'
                    : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <div className="pb-3">{children}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Accordion;
